// Tiny dependency-free sound effects via the Web Audio API.
// Synthesised tones (no asset files), respects a persisted mute flag.
const KEY = "choremouse_sfx_off";
let ctx;

function audioCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) ctx = new AC();
  }
  if (ctx && ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

export function isMuted() {
  try { return localStorage.getItem(KEY) === "1"; } catch (e) { console.debug("sfx: mute read failed", e); return false; }
}
export function setMuted(v) {
  try { localStorage.setItem(KEY, v ? "1" : "0"); } catch (e) { console.debug("sfx: mute write failed", e); }
}

function tone(c, freq, start, dur, type = "sine", gain = 0.18) {
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.value = freq;
  o.connect(g);
  g.connect(c.destination);
  const t = c.currentTime + start;
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(gain, t + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.start(t);
  o.stop(t + dur + 0.03);
}

export function playCheer() {
  if (isMuted()) return;
  try { const c = audioCtx(); if (!c) return; [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => tone(c, f, i * 0.09, 0.2, "triangle", 0.18)); } catch (e) { console.debug("sfx: cheer unavailable", e); }
}
export function playCoin() {
  if (isMuted()) return;
  try { const c = audioCtx(); if (!c) return; tone(c, 1046.5, 0, 0.1, "square", 0.15); tone(c, 1568, 0.08, 0.16, "square", 0.14); } catch (e) { console.debug("sfx: coin unavailable", e); }
}
export function playPop() {
  if (isMuted()) return;
  try { const c = audioCtx(); if (!c) return; tone(c, 660, 0, 0.09, "square", 0.16); tone(c, 990, 0.05, 0.09, "square", 0.12); } catch (e) { console.debug("sfx: pop unavailable", e); }
}
